import type { CountRoomsByZone } from "./types";

export const countRoomsByZone: CountRoomsByZone = ({ rooms }) => {
  const countByZoneId = new Map<number | null, number>();
  for (const room of rooms) {
    countByZoneId.set(room.zoneId, (countByZoneId.get(room.zoneId) ?? 0) + 1);
  }
  return countByZoneId;
};
